import { useState } from 'react';
import { type Lang, type Translations, translations, detectLang } from './translations';

export function useLanguage(): { lang: Lang; t: Translations; setLang: (l: Lang) => void } {
  const [lang, setLangState] = useState<Lang>(detectLang);

  const setLang = (l: Lang) => {
    localStorage.setItem('wb_lang', l);
    setLangState(l);
  };

  return { lang, t: translations[lang], setLang };
}
